export default __webpack_public_path__ + "static/opensea-2e929f84c55ca53a041adbe45a0d179b.png";